import AccountPage from "@/components/admin/dashboard/AccountPage.vue";
import CustomerPage from "@/components/admin/dashboard/CustomerPage.vue";
import DashboardPage from "@/components/admin/dashboard/DashboardPage.vue";
import ExportReceiptPage from "@/components/admin/dashboard/ExportReceiptPage.vue";
import OrderPage from "@/components/admin/dashboard/OrderPage.vue";
import ProductPage from "@/components/admin/dashboard/ProductPage.vue";
import SettingPage from "@/components/admin/dashboard/SettingPage.vue";
import StaticsPage from "@/components/admin/dashboard/StaticsPage.vue";
import SupplierPage from "@/components/admin/dashboard/SupplierPage.vue";
import AdminLayout from "@/components/admin/layouts/AdminLayout.vue";
import TechnicalStock from "@/components/admin/dashboard/TechnicalStock.vue";
import LoginAdmin from "@/components/admin/LoginAdmin.vue";
import RegisterAdmin from "@/components/admin/RegisterAdmin.vue";

const admin = [
  {
    path: "/login-admin.html",
    name: "LoginAdmin",
    component: LoginAdmin,
    meta: { title: "Đăng Nhập Quản Trị Viên - Store Thanh Danh" },
  },
  {
    path: "/register-admin.html",
    component: RegisterAdmin,
    meta: { title: "Đăng Ký Tài Khoản Quản Trị Viên - Store Thanh Danh" },
  },
  {
    path: "/admin",
    component: AdminLayout,
    meta: { title: "Admin Dashboard - Store Thanh Danh", requiresAuth: true },
    children: [
      {
        path: "dashboard.html",
        name: "AdminDashboard",
        component: DashboardPage,
        meta: {
          title: "Bảng Điều Khiển Quản Trị Viên - Store Thanh Danh",
          requiresAuth: true,
        },
      },
      {
        path: "technical-stock.html",
        name: "TechnicalStock",
        component: TechnicalStock,
        meta: { title: "Kho kĩ thuật - Store Thanh Danh", requiresAuth: true },
      },
      {
        path: "products.html",
        component: ProductPage,
        meta: {
          title: "Quản Lý Sản Phẩm - Store Thanh Danh",
          requiresAuth: true,
        },
      },
      {
        path: "export-receipts.html",
        name: "ExportReceipts",
        component: ExportReceiptPage,
        meta: {
          title: "Phiếu xuất kho - Store Thanh Danh",
          requiresAuth: true,
        },
      },
      {
        path: "customers.html",
        component: CustomerPage,
        meta: {
          title: "Quản Lý Khách Hàng - Store Thanh Danh",
          requiresAuth: true,
        },
      },
      {
        path: "orders.html",
        component: OrderPage,
        meta: {
          title: "Quản Lý Đơn Hàng - Store Thanh Danh",
          requiresAuth: true,
        },
      },
      {
        path: "suppliers.html",
        name: "Suppliers",
        component: SupplierPage,
        meta: { title: "Nhà cung cấp - Store Thanh Danh", requiresAuth: true },
      },
      {
        path: "statistics.html",
        name: "Statistics",
        component: StaticsPage,
        meta: { title: "Thống Kê - Store Thanh Danh", requiresAuth: true },
      },
      {
        path: "accounts.html",
        component: AccountPage,
        name: "AdminAccounts",
        meta: {
          title: "Quản Lý Tài Khoản - Store Thanh Danh",
          requiresAuth: true,
        },
      },
      {
        path: "setting.html",
        component: SettingPage,
        name: "AdminSetting",
        meta: {
          title: "Cài Đặt Hệ Thống - Store Thanh Danh",
          requiresAuth: true,
        },
      },
    ],
  },
];

export default admin;
